/* saluvivo: kleine Helfer für alle Seiten.
   1) Pfeil «Nach oben» (erscheint nach etwa einer Bildschirmhöhe).
   2) KI-Etiketten auf kleinen Bildern (unter 200 px breit) ausblenden.
   3) Handy: Sprungmenü (Adozan, BioTekna) als aufklappbare Liste «Auf dieser Seite» statt seitlich scrollen. */
(function(){
  if(window.svTop)return;window.svTop=true;
  var lang=(document.documentElement.lang||'de').slice(0,2);
  function init(){
    if(!document.querySelector('.sv-top')){
      var lbl=lang==='fr'?'Retour en haut':lang==='en'?'Back to top':'Nach oben';
      var b=document.createElement('button');b.type='button';b.className='sv-top';b.setAttribute('aria-label',lbl);b.title=lbl;
      b.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5.5 11.5L12 5l6.5 6.5"/></svg>';
      document.body.appendChild(b);
      var rm=window.matchMedia('(prefers-reduced-motion: reduce)');
      b.addEventListener('click',function(){window.scrollTo({top:0,behavior:rm.matches?'auto':'smooth'});b.blur();});
      var t=false;
      function upd(){t=false;b.classList.toggle('is-on',window.scrollY>window.innerHeight*0.9);}
      window.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(upd);}},{passive:true});
      upd();
    }
    small();jump();
  }

  /* KI-Etiketten: nur auf Bildern ab 200 px Breite zeigen */
  var q=false;
  function small(){
    q=false;
    document.querySelectorAll('.sv-ai,.svf__ai,.svl__ai').forEach(function(s){
      var p=s.parentElement;if(!p)return;var w=p.getBoundingClientRect().width;
      if(w>0)s.classList.toggle('sv-ai--small',w<200);
    });
  }
  function later(){if(!q){q=true;setTimeout(small,60);}}
  window.addEventListener('resize',later,{passive:true});
  window.addEventListener('load',later);
  document.addEventListener('click',function(){setTimeout(small,80);});
  if(window.MutationObserver){new MutationObserver(later).observe(document.documentElement,{childList:true,subtree:true});}

  /* Sprungmenü auf dem Handy: Knopf «Auf dieser Seite» klappt die Ziele als Liste auf */
  function jump(){
    var nav=document.querySelector('.page-anchor-nav');if(!nav||nav.dataset.svJump)return;nav.dataset.svJump='1';
    var inner=nav.querySelector('.page-anchor-nav__inner');if(!inner)return;
    var lbl=lang==='fr'?'Sur cette page':lang==='en'?'On this page':'Auf dieser Seite';
    var btn=document.createElement('button');btn.type='button';btn.className='sv-jump__btn';btn.setAttribute('aria-expanded','false');
    btn.innerHTML='<span>'+lbl+'</span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    nav.insertBefore(btn,inner);
    function set(open){nav.classList.toggle('is-open',open);btn.setAttribute('aria-expanded',open?'true':'false');}
    btn.addEventListener('click',function(){set(!nav.classList.contains('is-open'));});
    inner.addEventListener('click',function(e){if(e.target.closest('a'))set(false);});
    document.addEventListener('click',function(e){if(!nav.contains(e.target))set(false);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false);});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
